<!--
 * @Author: xuquantong
 * @Date: 2022-08-16 18:34:34
 * @LastEditors: xuquantong
 * @LastEditTime: 2022-08-31 14:59:15
 * @Description: 固定悬浮按钮，除商详页外所有页面都展示
-->
<template>
  <aside class="aside fix-menu" v-show="showMenu">
    <Overlay visible @click="showBtns = false" :zIndex="2001" class="overlay-common-new" v-show="showBtns" />
    <div :class="['menu-list', showBtns ? 'show' : '']">
      <a :href="`${linkBase}/`" @click="toggleMenu">首页</a>
      <a :href="`${linkBase}/category`" @click="toggleMenu">选购商品</a>
      <a :href="`${linkBase}/my`" @click="toggleMenu">个人中心</a>
    </div>
    <img class="btn-menu" src="~assets/img/common/fix-menu.png" @click="toggleMenu" />
  </aside>
</template>

<script>
import { Overlay } from '@vivo/shop-ui-h5'
import { mapState } from 'vuex'
export default {
  name: 'FixMenu',
  components: {
    Overlay
  },
  data() {
    return {
      showBtns: false // 是否显示菜单项
    }
  },
  computed: {
    ...mapState(['showMenu'])
  },
  methods: {
    toggleMenu() {
      this.showBtns = !this.showBtns
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
